
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path92834123"}},[_c('rect',{attrs:{"id":"Rectangle_15387","data-name":"Rectangle 15387","width":"20","height":"20","fill":"#1c84fa"}})])]),_c('g',{attrs:{"id":"Mask_Group_44899","data-name":"Mask Group 44899","clip-path":"url(#clip-path92834123)"}},[_c('g',{attrs:{"id":"URL","transform":"translate(2.997 3.007)","fill":"none","stroke":"#5a677d","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"id":"Path_28092","data-name":"Path 28092","d":"M12.375 10.175a3.5 3.5 0 005.277.382l2.1-2.1a3.5 3.5 0 00-4.948-4.948L13.6 4.7","transform":"translate(-6.771 -2.483)"}}),_c('path',{attrs:{"id":"Path_28093","data-name":"Path 28093","d":"M10.869 12.533a3.5 3.5 0 00-5.277-.382l-2.1 2.1A3.5 3.5 0 008.438 19.2l1.2-1.2","transform":"translate(-2.466 -6.24)"}})])])])
          )
        }
      }
    